import React from 'react';

export const useModal = (Modal, { onClose, ...rest }) => {
  const [props, setProps] = React.useState({ open: false, ...rest });

  const handleChange = (newProps) => {
    setProps({ ...props, ...newProps });
  };

  if (!props?.open) {
    return [<></>, handleChange];
  }

  return [
    <Modal
      key="modal"
      onClose={(...result) => {
        onClose()(...result);
      }}
      {...props}
    />,
    handleChange,
  ];
};

export default useModal;
